import {assert} from 'Asserts';

interface PaneArgs<TPaneKey extends string> {
  currentPaneKey: TPaneKey | null;
  excludedPanes: Array<TPaneKey>;
  offset: -1 | 1;
}

export default function switchPanes<TPaneKey extends string>(
  paneOrder: Array<TPaneKey>,
  {currentPaneKey, excludedPanes, offset}: PaneArgs<TPaneKey>
): TPaneKey {
  const panes = paneOrder.filter((paneKey) => !excludedPanes.includes(paneKey));

  const paneIndex = panes.findIndex((paneKey) => paneKey === currentPaneKey);
  assert(paneIndex !== -1, `Invalid pane "${currentPaneKey}"`);

  const newPaneIndex = paneIndex + offset;
  assert(newPaneIndex >= 0, 'Cannot go before first pane');
  assert(newPaneIndex < panes.length, 'Cannot go past last pane');
  return panes[newPaneIndex];
}
